import customPage from './validation/custom-page'
import workflow from './components/workflow'
import team from './components/team'
import organization from './components/organization'
import workspaces from './components/workspaces'
import plugins from './components/plugins'
import inputTemplateForm from './components/input-template-form'
import incidents from './components/incidents'
import insights from './components/insights'
import customTable from './components/custom-table'
import customPageBuilder from './components/custom-page-builder'
import customDomains, { errors as customDomainErrors } from './components/custom-domains'
import analyticsReports from './components/analytics-reports'
import breadcrumbs from './components/breadcrumbs'
import assets from './components/assets'
import designMigration from './components/design-migration'
import timeTriggers from './components/time-triggers'
import home from './components/home'
import customTableValidation from './validation/custom-table'

export default {
    validation: {
        'custom-page': customPage,
        'custom-table': customTableValidation,
    },
    common: {
        delete: 'Delete',
        preview: 'Preview',
        create: 'Create',
        submit: 'Submit',
        confirm: 'Confirm',
        save: 'Save',
        'save-changes': 'Save changes',
        close: 'Close',
        cancel: 'Cancel',
        oops: 'Ooops...',
        'something-went-wrong': 'Ooops... something went wrong',
        'try-again': 'Try again',
        success: 'Success',
        error: 'Error: {error}',
        'generic-error': 'Error',
        id: 'ID',
        language: 'Language',
        'discard-changes': 'You have unsaved changes. Are you sure you want to leave?',
        'select-all': 'Select all',
        'deselect-all': 'Deselect all',
        export: 'Export',
        import: 'Import',
        'download-as-json': 'Download as JSON',
        'copy-to-clipboard': 'Copy to clipboard',
        'copied-to-clipboard': 'Copied to clipboard',
        'exported-successfully': 'Exported successfully',
        'imported-successfully': 'Imported successfully',
        'import-failed': 'Import failed',
    },
    components: {
        breadcrumbs,
        workflow,
        team,
        plugins,
        incidents,
        'custom-table': customTable,
        'custom-page-builder': customPageBuilder,
        'custom-domains': customDomains,
        'input-template-form': inputTemplateForm,
        insights,
        'analytics-reports': analyticsReports,
        organization,
        assets,
        workspaces,
        'design-migration': designMigration,
        'time-triggers': timeTriggers,
        home,
    },
    errors: {
        teamMember: {
            alreadyExists: 'Team member with this email already exists',
        },
        ...customDomainErrors,
    },
}
